/**
 * @generated SignedSource<<d35cdeacf3f9d479d839a570e8623d54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupPostsCommentForm_comment$data = {
  readonly id: string;
  readonly rootParentCommentId: string | null | undefined;
  readonly " $fragmentType": "GroupPostsCommentForm_comment";
};
export type GroupPostsCommentForm_comment$key = {
  readonly " $data"?: GroupPostsCommentForm_comment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupPostsCommentForm_comment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupPostsCommentForm_comment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rootParentCommentId",
      "storageKey": null
    }
  ],
  "type": "GroupPostComment",
  "abstractKey": null
};

(node as any).hash = "4ff50b03f407de991ee6898cf96f2918";

export default node;
